export default __webpack_public_path__ + "static/2249-f90c389534c58801bf2630a0083a5b58.gif";